import React from "react";
import { Col, Container, Row } from "reactstrap";
import { IListOption } from "src/store/models/listOption.models";
import DeliveryInformationForm from "./DeliveryInformation/DeliveryInformation";
import PolicyInformationForm from "./PolicyInformation/PolicyInformation";
import ProposedInsuredForm from "./ProposedInsured/ProposedInsured";
import RelatedApplicationForm from "./RelatedApplication/RelatedApplication";

interface AppClientInfoProps {
  stateOptions: IListOption[];
  carrierOptions: IListOption[];
  statusOptions: IListOption[];
  productOptions: IListOption[];
  genderOptions: IListOption[];
  onStatusHistoryClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const AppClientInfo = ({
  stateOptions,
  carrierOptions,
  statusOptions,
  productOptions,
  onStatusHistoryClick,
  genderOptions,
}: AppClientInfoProps) => {
  return (
    <Container fluid className="client-info-container">
      <Row className="client-info-container__inner-container">
        <Col className="client-info-column">
          <ProposedInsuredForm stateOptions={stateOptions} genderOptions={genderOptions} />
        </Col>

        <Col className="client-info-column">
          <PolicyInformationForm
            carrierOptions={carrierOptions}
            statusOptions={statusOptions}
            productOptions={productOptions}
            onStatusHistoryClick={onStatusHistoryClick}
          />
        </Col>

        <Col className="client-info-column delivery-information-column">
          <Row className="client-info-inner-column">
            <Col>
              <DeliveryInformationForm />
            </Col>
            <Col>
              <RelatedApplicationForm />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default AppClientInfo;
